import { DialogComponentContent } from './../../../models/dialogs/DialogComponentContent';
import { Component, Inject, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppState } from '../../../interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { ApplicationMessagesAction } from '../../../state-management/application-messages/application-message.action';

@Component({
    templateUrl: './generic-error.component.html',
})

export class GenericErrorComponent extends DialogComponentContent {
    public confirmButtonLabel: string = 'Continue';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<GenericErrorComponent>,
        public element: ElementRef,
        private store: Store<AppState>,
    ) {
        super(element);
        if (data && data.buttonLabel) {
            this.confirmButtonLabel = data.buttonLabel;
        }
    }

    public dispose(): void {
        this.store.dispatch({type: ApplicationMessagesAction.genericErrorCompleted});
        this.close(this.dialogRef);
    }

}
